import "./App.css";
import { useEffect, useRef } from "react";
import Main from "./Component/Main";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import Faqs from "./Component/Faqs";
import Cookies from "./Component/Cookies";
import PaymentResult from "./Component/PaymentResult";
import productData, { siteConfig } from "./Datas/productData";

const pageTitles = {
  "/shop": "Shop all",
  "/cartpage": "Shopping bag",
  "/checkout": "Checkout",
  "/paysuccess": "Order confirmation",
  "/about": "Our story",
  "/contact": "Contact",
  "/shipping": "Shipping & delivery",
  "/returns": "Returns & refunds",
  "/privacy": "Privacy policy",
  "/terms": "Terms of service",
  "/cookies": "Cookie policy",
  "/faqs": "Frequently asked questions",
  "/payment": "Payment status",
};

function StorefrontRoutes() {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    const animationFrame = window.requestAnimationFrame(() => {
      const mainContent = document.querySelector("main");
      if (mainContent) {
        mainContent.id = "main-content";
        mainContent.tabIndex = -1;
        if (!firstRender.current) mainContent.focus({ preventScroll: true });
      }

      const productId = Number(location.pathname.split("/").pop());
      const product = productData.find((item) => item.id === productId);
      const pageTitle = location.pathname.startsWith("/shopDetails/")
        ? product?.name || "Product details"
        : pageTitles[location.pathname];
      const title =
        location.pathname === "/"
          ? `${siteConfig.brandName} | ${siteConfig.tagline}`
          : `${pageTitle || "Storefront"} | ${siteConfig.brandName}`;
      document.title = title;
      firstRender.current = false;
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/about" element={<About />} />
      <Route path="/shipping" element={<Delivery />} />
      <Route path="/" element={<Main />} />
      <Route path="/returns" element={<Returns />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/faqs" element={<Faqs />} />
      <Route path="/payment" element={<PaymentResult />} />
      <Route path="/shopDetails/:id" element={<ProductDetail />} />
      <Route path="/cartpage" element={<CartPage />} />
      <Route path="/checkout" element={<CheckOut />} />
      <Route path="/paysuccess" element={<PaymentResult />} />
    </Routes>
  );
}

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <a className="skip-link" href="#main-content">
          Skip to content
        </a>
        <Header />
        <StorefrontRoutes />
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
